<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
import StepHeader from '../components/StepHeader.vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToBack = () => {
  location.replace('#/claim/start')
}

const clickToCancel = () => {
  if (!confirm('Are you sure?')) {
    return
  }

  location.replace('#/order')
}

const addPhotos = () => {
  // console.log('addPhotos')
  location.replace('#/claim/damage')
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const orderNumber = ref(data?.orderNumber ?? '')
const items = reactive(readSelectedItems() ?? [])
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})
//endregion
</script>

<template>

<!--
<figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>
-->

  <div class="px-[20px] my-[30px] lg:px-[40px]">

    <step-header :data="data" :items="items"/>

    <main class="lg:max-w-[420px] mx-auto">

      <div class="flex flex-row items-center mb-[20px]">
        <button type="button" @click="clickToBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h1 class="font-bold text-tc-subtitle font-minionpro" v-text="`Add photos of damaged item`"></h1>
      </div>

      <p class="text-black font-avenir text-tc-xl tracking-wide leading-normal">
<!--        Please upload photos showing damage to the item and/or packaging. Make sure each photo has good lighting and clearly shows the damage.-->
        Our customer service team will ask you to send evidence once first review has been performed on this claim.
      </p>

      <button type="button"
          @click="addPhotos"
          class="text-black font-medium font-avenir text-tc-xl tracking-wide bg-tc-off-white-two h-[50px] w-full lg:w-[380px] mt-[30px] lg:mx-auto"
      >
      <!-- + Add Photos -->
        Next
      </button>

      <div class="my-[30px] flex flex-row">
        <button type="button"
            @click="clickToCancel"
            class="text-tc-xl text-black font-avenir tracking-wide py-2.5 px-8 border-b border-tc-creme"
        >Cancel
        </button>
      </div>

    </main>

  </div>

</template>

<style scoped>
</style>